import { createContext } from 'react';

import { DropdownState } from './useDropdownWithAutocomplete';

export const DropdownContext = createContext<DropdownState<any>>(
  undefined as never
);
